export default __webpack_public_path__ + "static/media/tc.df6f3e13.svg";